type SpinnerSize = 'sm' | 'md' | 'lg';

type SpinnerProps = {
  size?: SpinnerSize;
};

const sizeMap: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

function Spinner({ size = 'md' }: SpinnerProps) {
  return (
    <div
      className={`${sizeMap[size]} animate-spin rounded-full border-2 border-slate-200 border-t-indigo-600`}
      role="status"
      aria-label="Loading"
    />
  );
}

export default Spinner;
